import type { QueryClient } from "@tanstack/react-query";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";

const readClientId = (variables: unknown) => {
	if (typeof variables !== "object" || variables === null) return undefined;

	const clientId = (variables as { clientId?: unknown }).clientId;

	return typeof clientId === "string" ? clientId : undefined;
};

export const getQueuedChatClientIds = (
	queryClient: QueryClient,
	conversationId: number | null,
): ReadonlySet<string> => {
	const clientIds = queryClient
		.getMutationCache()
		.findAll({ mutationKey: ChatKeys.send(conversationId), status: "pending" })
		.map((mutation) => readClientId(mutation.state.variables))
		.filter((clientId): clientId is string => clientId !== undefined);

	return new Set(clientIds);
};
